// i18n bootstrap. Industry-specific copy still lives in industry config
// (resolved via useCopy); i18next handles cross-industry system messages
// and is the seam for adding extra languages later (Arabic/RTL etc.).
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import ar from './ar.json';
import hi from './hi.json';
import ta from './ta.json';

const STORAGE_KEY = 'storefront-language';

function detectInitialLanguage() {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored) return String(stored).toLowerCase().split('-')[0];
  } catch {
    // Ignore storage access issues.
  }
  try {
    const browserLang = navigator.language || navigator.languages?.[0];
    if (browserLang) return String(browserLang).toLowerCase().split('-')[0];
  } catch {
    // Ignore navigator access issues.
  }
  return 'en';
}

const RESOURCES = {
  en: { translation: en },
  ar: { translation: ar },
  hi: { translation: hi },
  ta: { translation: ta },
};

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources: RESOURCES,
    lng: detectInitialLanguage(),
    fallbackLng: 'en',
    supportedLngs: ['en', 'ar', 'hi', 'ta'],
    load: 'languageOnly',
    interpolation: { escapeValue: false },
    returnNull: false,
  });
}

export default i18n;
